import { Palette } from 'config';
import styled from 'styled-components';

export const Field = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  justify-content: space-between;
`;

export const Label = styled.label`
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  color: ${Palette.PrimaryGray._700};
`;

export const Requirements = styled.label`
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  color: ${Palette.PrimaryGray._500};
  display: flex;
  gap: 4px;
`;

export const ReqWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const Marker = styled.label`
  padding: 0px 5px;
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  background-color: ${Palette.PrimaryGray._200};
  color: ${Palette.PrimaryGray._400};
  border-radius: 50%;
  cursor: pointer;
`;

export const DialogFooterSection = styled.div`
  display: flex;
  width: 100%;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  padding: 20px 24px;
  background-color: #f8fafc;
`;
export const DialogFooterButtons = styled.div`
  gap: 16px;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: flex-start;
  padding: 0px;
  border-width: 0px;
  box-sizing: content-box;
  background: none;
`;

export const Form = styled.form`
  all: unset;
  display: block;
  width: 100%;
  box-sizing: border-box;
  overflow-x: hidden;
`;

export const Container = styled.div`
  padding: 24px 24px 0;
  overflow-x: hidden;
  width: 100%;
  box-sizing: border-box;
`;
